// 对话框默认对齐方式
export const DIALOG_ALIGN = 'center';

// 显示mask触发
export const ON_MASK_SHOW = ()=>{};

// 隐藏mask触发
export const ON_MASK_HIDE = ()=>{};

// 是否把https换成http
export const IS_ALLOW_HTTPS = true;


// WEBPACK FOOTER //
// ./src/packages/config/default.js